module.exports = __webpack_public_path__ + "static/media/logo.531aa21a.jpg";